import { ActionTypes } from '../../constants/ActionTypes';
import { IGetGuidReduicer } from '../../interfaces/GetGuid';
const INIT_STATE: IGetGuidReduicer = {
  guid: '',
};

export default (state = INIT_STATE, action: any) => {
  switch (action.type) {
    case ActionTypes.GET_GUID: {
      return {
        ...state,
      };
    }

    case ActionTypes.GET_GUID_Success: {
      return {
        ...state,
        guid: action.payload,
      };
    }

    default:
      return state;
  }
};
